var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo--twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.94 18.7045C10.2069 18.7125 11.4627 18.4688 12.6346 17.9877C13.8066 17.5066 14.8714 16.7975 15.7672 15.9017C16.663 15.0059 17.3721 13.9411 17.8532 12.7691C18.3343 11.5972 18.578 10.3414 18.57 9.0745C18.57 8.9245 18.57 8.782 18.57 8.632C19.2267 8.15087 19.7951 7.55963 20.25 6.8845C19.6316 7.15495 18.9773 7.33431 18.3075 7.417C19.0177 6.99384 19.5506 6.32775 19.8075 5.542C19.1456 5.93908 18.4199 6.21823 17.6625 6.367C17.1524 5.82352 16.4775 5.46329 15.7421 5.34204C15.0067 5.22079 14.2518 5.34527 13.5943 5.69624C12.9368 6.04721 12.4132 6.60509 12.1047 7.28356C11.7962 7.96203 11.7198 8.72327 11.8875 9.4495C10.542 9.38346 9.22553 9.03477 8.02377 8.42613C6.822 7.81749 5.7619 6.96256 4.9125 5.917C4.48419 6.66038 4.35437 7.53874 4.54932 8.37424C4.74427 9.20974 5.24942 9.93994 5.9625 10.417C5.43646 10.3967 4.92259 10.2528 4.4625 9.997V10.0345C4.45783 10.8114 4.71954 11.5664 5.20403 12.1737C5.68851 12.781 6.3665 13.2039 7.125 13.372C6.63573 13.5036 6.12322 13.5241 5.625 13.432C5.84459 14.0945 6.26376 14.6729 6.82503 15.0878C7.38631 15.5028 8.06219 15.7339 8.76 15.7495C7.56691 16.7099 6.08407 17.2385 4.5525 17.2495C4.28396 17.2417 4.01606 17.2192 3.75 17.182C5.30022 18.1697 7.1019 18.6904 8.94 18.682",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.296ab59a82a57f2a78a3481457ce800f.svg";
export { ForwardRef as ReactComponent };